'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Printerless = props => /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.0123 26.2537C25.0123 26.534 24.7774 26.7617 24.4876 26.7617H17.2564L17.257 23.9516C17.257 23.9504 17.2564 23.9493 17.2564 23.9482V23.9207C17.2564 23.4316 16.8515 23.0345 16.3528 23.0345H11.5768C11.0787 23.0345 10.6732 23.4316 10.6732 23.9207V26.7617H3.25958C2.96979 26.7617 2.73489 26.534 2.73489 26.2537V10.612H10.6283H10.6732V13.2551C10.6732 13.7242 11.0787 14.1064 11.5768 14.1064H16.3528C16.8515 14.1064 17.2564 13.7242 17.2564 13.2551L17.2546 10.612H17.3024H25.0123V26.2537ZM16.521 26.7618H11.4086L11.4092 23.9516C11.4092 23.8561 11.4847 23.7783 11.5774 23.7783H16.354C16.4454 23.7783 16.5198 23.8555 16.521 23.9499V26.7618ZM6.34519 3.36657C6.40362 3.25901 6.51694 3.19093 6.6403 3.19036L11.5178 3.1875L10.7133 9.89932H2.96389L6.34519 3.36657ZM16.521 10.612V13.2551C16.521 13.3312 16.4455 13.3936 16.3528 13.3936H11.5769C11.4842 13.3936 11.4086 13.3312 11.4086 13.2551L11.4069 10.612H16.521ZM15.75 3.87169L16.4766 9.89929H11.4539L12.2589 3.18804L15.668 3.19147L15.75 3.87169ZM21.0773 3.19776C21.206 3.19776 21.3216 3.26698 21.3801 3.38026L24.782 9.89928H17.2167L16.4088 3.19375L21.0773 3.19776ZM25.7081 10.0949L22.037 3.05986C21.854 2.70574 21.4875 2.48548 21.0785 2.48491L16.3226 2.4809V2.47976L11.9308 2.47461H11.922H11.6033V2.47518L6.63786 2.47747C6.23947 2.47976 5.87649 2.69429 5.69057 3.04213L2.03836 10.0961C2.01298 10.1458 2 10.2002 2 10.2557V26.2538C2 26.9271 2.56483 27.4746 3.2595 27.4746H10.6731H11.0408H16.8886H17.2563H24.4875C25.1822 27.4746 25.7476 26.9271 25.7476 26.2538V10.2557C25.7476 10.2002 25.734 10.1447 25.7081 10.0949Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M30.8663 18.5569C30.8663 21.649 28.3596 24.1557 25.2674 24.1557C22.1753 24.1557 19.6686 21.649 19.6686 18.5569C19.6686 15.4647 22.1753 12.958 25.2674 12.958C28.3596 12.958 30.8663 15.4647 30.8663 18.5569Z",
  fill: "white"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.2674 23.5159C28.0062 23.5159 30.2264 21.2957 30.2264 18.5569C30.2264 15.8181 28.0062 13.5979 25.2674 13.5979C22.5287 13.5979 20.3084 15.8181 20.3084 18.5569C20.3084 21.2957 22.5287 23.5159 25.2674 23.5159ZM25.2674 24.1557C28.3596 24.1557 30.8663 21.649 30.8663 18.5569C30.8663 15.4647 28.3596 12.958 25.2674 12.958C22.1753 12.958 19.6686 15.4647 19.6686 18.5569C19.6686 21.649 22.1753 24.1557 25.2674 24.1557Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M23.2678 16.5587H23.9877V17.2786H23.2678V16.5587Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M24.7075 15.8389V17.9984H22.548V15.8389H24.7075ZM24.3476 16.1988H22.9079V17.6385H24.3476V16.1988Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M23.9877 20.158H23.2678V20.8779H23.9877V20.158Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M24.7075 19.4381V21.5977H22.548V19.4381H24.7075ZM22.9079 19.7981V21.2378H24.3476V19.7981H22.9079Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M26.8671 16.5587H27.587V17.2786H26.8671V16.5587Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M26.1472 15.8389V17.9984H28.3068V15.8389H26.1472ZM27.9469 16.1988V17.6385H26.5072V16.1988H27.9469Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M25.4274 16.1988V15.8389H25.7873V16.5587H25.4274V17.2786H25.0675V16.1988H25.4274Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M25.4274 17.9984V17.2786H25.7873V17.9984H25.4274Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M24.7075 18.7183V18.3584H25.0675V17.9984H25.4274V18.7183H25.7873V18.3584H27.587V18.7183H26.1472V19.0782H25.0675V18.7183H24.7075Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M24.7075 18.7183V19.0782H23.2678V18.7183H22.9079V19.0782H22.548V18.3584H23.6278V18.7183H24.7075Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M28.3068 19.0782H27.9469V18.3584H28.3068V19.0782Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M27.9469 19.0782H27.587V19.7981H28.3068V19.4381H27.9469V19.0782Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M26.5072 19.0782H27.227V19.4381H26.8671V19.7981H26.5072V19.0782Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M27.227 20.158V19.7981H26.8671V20.158H26.5072V20.5179H25.7873V20.8779H26.8671V20.158H27.227Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M27.227 20.158H28.3068V20.5179H27.587V20.8779H27.227V20.158Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M25.7873 19.7981V20.158H26.1472V19.4381H25.0675V19.7981H25.7873Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M25.0675 20.158H25.4274V21.2378H26.8671V21.5977H25.0675V20.158Z",
  fill: "black"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M28.3068 20.8779V21.5977H27.227V21.2378H27.9469V20.8779H28.3068Z",
  fill: "black"
}));

exports["default"] = Printerless;
